import useSWR, { SWRResponse } from "swr";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";
import { generateUrl } from "../../utils/http";

interface TransactionsResponse {
  data: any[];
  total: number;
}

interface UseTransactionsParams {
  current: number;
  pageSize: number;
}

const useTransactions = (
  pagination: UseTransactionsParams
): SWRResponse<TransactionsResponse, Error> => {
  const httpClient: AxiosInstance = useHttpClient();
  const key = pagination
    ? `transactions-${pagination.current}-${pagination.pageSize}`
    : null;

  return useSWR(
    key,
    async (): Promise<TransactionsResponse> => {
      const response = await httpClient.get(
        generateUrl({
          url: "/transactions",
          query: {
            _page: pagination.current.toString(),
            _page_size: pagination.pageSize.toString(),
            _sort: "id",
            _order: "DESC",
            _attributes:
              "id,amount,channel,exchangedAmount,currency,description,succeededAt,channelId,type,status,fee",
          },
        })
      );
      return {
        data: response.data.data,
        total: response.data.total,
      };
    },
    {
      revalidateOnFocus: true,
      revalidateIfStale: true,
    }
  );
};

export default useTransactions;

